import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataShareService {
  laboursArrayDataShareService: any[] = [];
  menuArrayDataShareService: any[] = [];
  globalCodesArrayDataShareService: any[] = [];
  contractorsArrayDataShareService: any[] = [];
  leaveTypesArrayDataShareService: any[] = [];
  payrollMonthArrayDataShareService: any[] = [];
  plantsArrayDataShareService: any[] = [];
  skillMasterArrayDataShareService: any[] = [];
  userDataAccessDetailsArrayDataShareService: any[] = [];
  plantUnitDepartmentTreeArrayDataShareService: any[] = [];
  masterDataArrayDataShareService: any[] = [];
  masterData_V2_ArrayDataShareService: any[] = [];
  
  contractorFlowArrayDataShareService: any[] = [];
  workOrderFlowArrayDataShareService: any[] = [];
  newLicenseFlowArrayDataShareService: any[] = [];
  oldLicenseFlowArrayDataShareService: any[] = [];

  constructor() { }
  private subject = new Subject<any>();

  shareData(data: any) {
    this.subject.next(data);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  updateArrayWithObject(array: any[], where: any[], setData: { [s: string]: unknown; } | ArrayLike<unknown>) {
    let objIndex = array.findIndex((obj => obj[where[0]] == where[1]));
    if (objIndex >= 0) {
      for (const [k, v] of Object.entries(setData)) {
        array[objIndex][k] = v;
      }
    }
    return array;
  }

  removeObjectInArray(array: any[], where: any[]) {
    let objIndex = array.findIndex((obj => obj[where[0]] == where[1]))
    if (objIndex >= 0) {
        array.splice(objIndex, 1);
    }
    return array;
}

// captureImage(type: string): void {
//     const modalRef = this.modalService.open(LabourProfileImageComponent, {
//       size: "lg",
//       backdrop: "static", windowClass: 'modal-scrollbar-hide'
//     });
  
//     const selectedImage = type === "photo" ? this.savedCroppedImage
//       : type === "left" && this.leftFinger !== undefined ? this.leftHandData[this.leftFinger]
//         : type === "right" && this.rightFinger !== undefined ? this.rightHandData[this.rightFinger]
//           : null;
  
//     modalRef.componentInstance.image = selectedImage;
//     modalRef.componentInstance.croppedImage.subscribe((arg: any) => {
//       if (arg) {
//         this.compressBase64(arg, 0.5).then((compressedImage) => { // Compress Before Saving
//           if (type === "photo") {
//             this.savedCroppedImage = compressedImage;
//             this.selectedLabour.Photo = compressedImage;
//           } else if (type === "left" && this.leftFinger !== undefined) {
//             this.leftFingerImage = compressedImage;
//             this.leftHandData[this.leftFinger] = compressedImage;
//             this.selectedLabour[`Left${this.leftFinger}`] = compressedImage;
//           } else if (type === "right" && this.rightFinger !== undefined) {
//             this.rightFingerImage = compressedImage;
//             this.rightHandData[this.rightFinger] = compressedImage;
//             this.selectedLabour[`Right${this.rightFinger}`] = compressedImage;
//           }
//         });
//       }
//     });
//   }
  
//   /**
//    * Compress Base64 Image
//    * @param base64Str Base64 String
//    * @param quality Compression Quality (0.1 - 1)
//    * @returns Compressed Base64
//    */
//   compressBase64(base64Str: string, quality: number): Promise<string> {
//     return new Promise((resolve) => {
//       const img = new Image();
//       img.src = base64Str;
//       img.onload = () => {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");
        
//         // Reduce Size (Resize if needed)
//         canvas.width = img.width / 2;
//         canvas.height = img.height / 2;
  
//         ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
//         // Convert to Compressed Base64
//         const compressedBase64 = canvas.toDataURL("image/jpeg", quality);
//         resolve(compressedBase64);
//       };
//     });
//   }
}


